import React from 'react'
import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'

function Formula1Widget() {
  return (
    <CustomLink href={'/formula1-racing'}>
      <div className={styles.container}>
      </div>
    </CustomLink>
  )
}

export default Formula1Widget
